import _ from 'lodash'
import qs from 'qs'
import { toast } from 'react-toastify'

import api from '../lib/api'

import { push } from 'react-router-redux'

export const LIST_MAIN_AREAS_SUCCESS = 'LIST_MAIN_AREAS_SUCCESS'
export const LIST_MAIN_AREAS_FAILURE = 'LIST_MAIN_AREAS_FAILURE'
export const SET_MAIN_AREA_IS_LOADING_SUCCESS = 'SET_MAIN_AREA_IS_LOADING_SUCCESS'
export const SET_MAIN_AREA_SELECTED_SUCCESS = 'SET_MAIN_AREA_SELECTED_SUCCESS'
export const CLEAR_MAIN_AREA_KEY_SUCCESS = 'CLEAR_MAIN_AREA_KEY_SUCCESS'
export const CLEAR_MAIN_AREA_ERRORS = 'CLEAR_MAIN_AREA_ERRORS'
export const SET_MAIN_AREA_ERRORS = 'SET_MAIN_AREA_ERRORS'
export const CREATE_MAIN_AREA_SUCCESS = 'CREATE_MAIN_AREA_SUCCESS'
export const CREATE_MAIN_AREA_FAILURE = 'CREATE_MAIN_AREA_FAILURE'
export const GET_MAIN_AREAS_SUCCESS = 'GET_MAIN_AREAS_SUCCESS'
export const GET_MAIN_AREAS_FAILURE = 'GET_MAIN_AREAS_FAILURE'
export const CLEAR_MAIN_AREA_SUCCESS = 'CLEAR_MAIN_AREA_SUCCESS'
export const READ_MAIN_AREA_SUCCESS = 'READ_MAIN_AREA_SUCCESS'
export const READ_MAIN_AREA_FAILURE = 'READ_MAIN_AREA_FAILURE'
export const UPDATE_MAIN_AREA_SUCCESS = 'UPDATE_MAIN_AREA_SUCCESS'
export const UPDATE_MAIN_AREA_FAILURE = 'UPDATE_MAIN_AREA_FAILURE'
export const SET_IS_ADD_MAIN_AREA = 'SET_IS_ADD_MAIN_AREA'

export const listMainAreas = (query, key) => async dispatch => {
  try {
    const defaultQuery = { limit: process.env.REACT_APP_PAGE_LIMIT, page: 1 }

    const { data } = query.limit != -1 ? await api.get(`/api/main-areas?${qs.stringify(_.merge(defaultQuery, query))}`) 
      : await api.get(`/api/main-areas?${qs.stringify(_.merge(query))}`)
    dispatch({ type: LIST_MAIN_AREAS_SUCCESS, data: { query, list: data, key } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the main areas.')
    console.log(err.msg)
    dispatch({ type: LIST_MAIN_AREAS_FAILURE, err })
  }
}

export const readMainArea = (mainAreaId) => async dispatch => {
  try {
    console.log('read main area')
    dispatch({ type: CLEAR_MAIN_AREA_SUCCESS })
    const { data } = await api.get(`/api/main-areas/${mainAreaId}`)
    dispatch({ type: READ_MAIN_AREA_SUCCESS, data: { current: data } })
  } catch (err) {
    toast.error('Failed to retrieve the project.')
    dispatch({ type: READ_MAIN_AREA_FAILURE, err })
  }
}

export const getMainAreas = (query) => async dispatch => {
  try {
    const defaultQuery = { limit: process.env.REACT_APP_PAGE_LIMIT, page: 1 }
    const { data } = await api.get(`/api/main-areas?${qs.stringify(_.merge(defaultQuery, query))}`)
    dispatch({ type: GET_MAIN_AREAS_SUCCESS, data: { query, list: data } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the main areas.')
    console.log(err.msg)
    dispatch({ type: GET_MAIN_AREAS_FAILURE, err })
  }
}

export const createMainArea = (mainArea) => async dispatch => {
  try {
      const { data } = await api.post('/api/main-areas', mainArea)
    await dispatch({type: CREATE_MAIN_AREA_SUCCESS, data: { newMainArea: data } })
    // dispatch(push('/mainArea'))
  } catch (error) {
    toast.error('Failed to create a mainarea')
    dispatch({ type: CREATE_MAIN_AREA_FAILURE, error })
  }
}

export const updateMainArea = (mainArea) => async dispatch => {
  try {
    console.log(mainArea)
    await api.put(`/api/main-areas/${mainArea.id}`, mainArea)
    await dispatch({ type: UPDATE_MAIN_AREA_SUCCESS })
    dispatch(push('/mainArea'))
  } catch (err) {
    toast.error('Failed to update the mainarea.')
    dispatch({ type: UPDATE_MAIN_AREA_FAILURE, err })
  }
}


export const setMainAreaIsLoading = (isLoading, key) => dispatch => {
  dispatch({ type: SET_MAIN_AREA_IS_LOADING_SUCCESS, data: { isLoading, key } })
}

export const setMainAreaSelected = (selected, key) => dispatch => {
  if (selected.length > 0) {
      dispatch({ type: SET_MAIN_AREA_SELECTED_SUCCESS, data: { selected, key } })
  }
}

export const clearMainAreaKey = (key) => dispatch => {
  dispatch({ type: CLEAR_MAIN_AREA_KEY_SUCCESS, data: { key } })
}

export const clearMainAreaErrors = () => dispatch => {
  dispatch({ type: CLEAR_MAIN_AREA_ERRORS })
}

export const setMainAreaErrors = (errors) => dispatch => {
  dispatch({ type: SET_MAIN_AREA_ERRORS, data: { errors } })
}

export const setIsAddMainArea = (isAddMainArea, key) => dispatch => {
    dispatch({ type: SET_IS_ADD_MAIN_AREA, data: { isAddMainArea, key } })
}





// WEBPACK FOOTER //
// ./src/actions/main-area.js